$(document).foundation();


function initMobileMenuControls() {
	var items = $("#menu .l1-item").length;

	$("#menu .l1-item").on("click", function() {
		var itemCount = $(this).find(".sub-menu li").length;

		if (itemCount >= items) {
			$("#menu-wrap .menu-btm").css("transform", "translateY(" + (((itemCount + 1) - items) * 52).toString() + "px)");
		}
	});

	$(document).on("click", "#menu .l1-item .btn-close-sub", function() {
		$("#menu-wrap .menu-btm").css("transform", "none");
	});
}

$(function() {

    //---------------------------------------------------------
    //  Elements
    //---------------------------------------------------------

    function formattedSliderResize(){
        $('.formatted-slider').each( function() {
            let maxSize=0;
            let formattedSlider = $(this);

            formattedSlider.find( '.item-hidden' ).each( function() {
                if($(this).height()>maxSize){
                    maxSize=$(this).height();
                }
            });

            maxSize=maxSize+145;
            formattedSlider.children('.item').each(function() {
                $(this).height(maxSize);
            });
            formattedSlider.height(maxSize);
        });
    }

    if ($('.rellax').length > 0) {
        var rellax = new Rellax('.rellax', {});
    }

    if ($('.multicolumn-carousel').length > 0) {
        $('.multicolumn-carousel').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay:true,
            speed: 1000,
            dots: false,
            appendArrows: $('.multicolumn-carousel-wrap'),
            prevArrow:'<a class="slider-prev"><i class="fal fa-chevron-left"></i></a>',
            nextArrow:'<a class="slider-next"><i class="fal fa-chevron-right"></i></a>',
            responsive: [
              {
                breakpoint: 500,
                settings: {
                    arrows: false
                }
              },
            ]
        });
    }

    if ($('.formatted-slider').length > 0) {

        $( window ).resize(function() {
            formattedSliderResize();
        });

        $(document).on('click', '.slider-next', function() {
            var nextButton = $(this);
            var currentSlide = nextButton.closest(".item");
            var currentSlidePos = nextButton.closest(".item").data('pos');
            var sliderContainer = nextButton.closest( ".formatted-slider" );
            var slideCount = sliderContainer.data('count');

            var nextSlide=2;

            if (slideCount==1){
                nextSlide=1;
            }
            else if (currentSlidePos==slideCount) {
                nextSlide=1;

            }
            else {
                nextSlide=currentSlidePos+1;
            }


            currentSlide.removeClass('active');
            sliderContainer.children('.item').each(function() {
                if ($(this).data('pos')==nextSlide){
                    $(this).addClass('active')
                }
            });

        });
    }

    if ($('.featured-blog-slider').length > 0) {
        $('.featured-blog-slider').slick({
            infinite: true,
            slidesToShow: 2.75,
            slidesToScroll: 0,
            // speed: 1000,
            autoplay: true,
            // autoplaySpeed: 2000,
            dots: false,
            appendArrows: $('.formatted-slider-wrap'),
            prevArrow:'',
            nextArrow:'',

            centerMode:true,
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                      slidesToShow: 2,
                  }
                },
                {
                  breakpoint: 640,
                  settings: {
                      // centerMode:false,
                      slidesToShow: 1.15,
                  }
                },
            ]
        });

        $(document).on('click', '.slider-next', function() {
            $(".featured-blog-slider").slick('slickNext');
        });
    }

    if ($('.content-slider').length > 0) {
        $('.content-slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay:true,
            speed: 600,
            dots: true,
            appendDots: $('.content-slider-wrap'),
            appendArrows: $('.content-slider-wrap'),
            prevArrow:'<a class="slider-prev"><i class="fal fa-chevron-left"></i></a>',
            nextArrow:'<a class="slider-next"><i class="fal fa-chevron-right"></i></a>',
            responsive: [
              {
                breakpoint: 500,
                settings: {
                    arrows: false
                }
              },
            ]
        });
    }

    if ($('.image-carousel').length > 0) {

        $( '.image-carousel' ).each( function() {

            $(this).slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay:true,
                autoplaySpeed:10000,
                speed: 600,
                dots: false,
                fade:true,
                // appendArrows: $('.image-carousel-wrap'),
                prevArrow:'',
                // nextArrow:'<a class="slider-next">Next <i class="fal fa-long-arrow-right"></i></a>',
                responsive: [ { breakpoint: 500 }, ]
            });

        });



    }

    if ($('.tile-slider').length > 0) {
        $('.tile-slider').slick({
            infinite: true,
            slidesToShow: $('.tile-slider').data("count"),
            slidesToScroll: 1,
            autoplay:true,
            speed: 600,
            dots: false,
            appendArrows: $('.tile-grid-wrap'),
            prevArrow:'<a class="slider-prev"><i class="fal fa-chevron-left"></i></a>',
            nextArrow:'<a class="slider-next"><i class="fal fa-chevron-right"></i></a>',
            responsive: [
              {
                breakpoint: 500,
                settings: {
                    arrows: false
                }
              },
            ]
        });
    }


    function isElementInViewport (el) {
        if (typeof jQuery === "function" && el instanceof jQuery) {
            el = el[0];
        }
        var rect = el.getBoundingClientRect();

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
            rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
        );
    }
    //---------------------------------------------------------


    //---------------------------------------------------------
    //  Header functionality
    //---------------------------------------------------------
    // if (Foundation.MediaQuery.current == 'small') {
            var threshold = 100;
    // } else {
    //     var threshold = $('#page-heading').hasClass('height-standard') ? 100 : 200;
    // }

    if ($(document).scrollTop() > threshold) {
        $('#header').addClass('solid');
    }

    $(window).scroll(function() {
        $( '.fade-content:in-viewport( 900 )' ).addClass('show-content');

        // if (Foundation.MediaQuery.current == 'small') {
            var scrollThreshold = 100;
        // } else {
        //     var scrollThreshold = $('#page-heading').hasClass('height-Standard') ? 100 : 200;
        // }

        if ($(document).scrollTop() > scrollThreshold) {
            $('#header').addClass('solid');
        }
        else {
            $('#header').removeClass('solid');
        }

        if ($('.tile-center').length > 0) {
            if(isElementInViewport($('.tile-center'))){
                if (!$('.tile-grid').hasClass('burst')) {
                    $('.tile-grid').addClass('burst');
                }
            }
        }

    });
    //---------------------------------------------------------


    //---------------------------------------------------------
    //  Dropdown Navigation Menu
    //---------------------------------------------------------
    $(document).on('click', '.icon-menu', function() {
        $(this).toggleClass('open');
        $('#dropdown-menu').toggleClass('open');
        $('#header').toggleClass('menu-open');
        $('body').toggleClass('menu-open');
        if ($(this).hasClass('open')) {
            $('#nav-shade').fadeIn(300);
        } else {
            $('#nav-shade').fadeOut(300);
        }
    });

    $(document).on('click', '#nav-shade', function() {
        $('.icon-menu').removeClass('open');
        $('#dropdown-menu').removeClass('open');
        $('#header').removeClass('menu-open');
        $('body').removeClass('menu-open');
        $('#nav-shade').fadeOut(300);
    });

    $(document).on('click', '.sub-menu-expand', function() {
        $(this).toggleClass('open');
        $(this).parent().find('.sub-menu').toggleClass('open');
    });
    //---------------------------------------------------------


    //---------------------------------------------------------
    //  Flyout menu
    //---------------------------------------------------------
    $(document).on('click', '.btn-mobile-menu', function() {
        $(this).toggleClass('open');
        $('body').toggleClass('menu-open');
        $('#flyout-menu').toggleClass('open');

        $('.menu-open-logo').toggleClass('open');
        $('.menu-closed-logo').toggleClass('open');


        return false;
    });

    $(document).on('click', '.link-parent-mobile', function() {
        $('.sub-menu').removeClass('mobile-open');
        $(this).parent().next('.sub-menu').addClass('mobile-open');
        $('#menu').addClass('sub-open');
        return false;
    });

    $(document).on('click', '.btn-close-sub', function() {
        $('.sub-menu').removeClass('mobile-open');
        $('#menu').removeClass('sub-open');
    });

	if (window.innerWidth < 700) initMobileMenuControls();
    //---------------------------------------------------------


    // Social Sharing
    $('.share-twitter').click(function(event) {
        var width  = 575,
            height = 400,
            left   = ($(window).width()  - width)  / 2,
            top    = ($(window).height() - height) / 2,
            url    = $(this).data('link'),
            opts   = 'status=1' +
                ',width='  + width  +
                ',height=' + height +
                ',top='    + top    +
                ',left='   + left;

        window.open('https://twitter.com/share?'+url, 'twitter', opts);

        return false;
    });

    $('.share-facebook').click(function(event) {
        var width  = 626,
            height = 436,
            left   = ($(window).width()  - width)  / 2,
            top    = ($(window).height() - height) / 2,
            url    = $(this).data('link'),
            title  = $(this).data('title'),
            desc  = $(this).data('description'),
            opts   = 'status=1' +
                ',width='  + width  +
                ',height=' + height +
                ',top='    + top    +
                ',left='   + left;

        window.open('http://www.facebook.com/dialog/share?app_id=976604439428115'+
              '&href='+url+
              '&redirect_uri='+url+
              '&display=popup', '_blank', 'width=420, height=300,left='+left+',top='+top+'');

        return false;
    });

    $('.share-linkedin').click(function(event) {
        var width  = 626,
            height = 436,
            left   = ($(window).width()  - width)  / 2,
            top    = ($(window).height() - height) / 2,
            url    = $(this).data('link');

        window.open('https://www.linkedin.com/sharing/share-offsite/?url='+url
             , '_blank', 'width=600, height=600,left='+left+',top='+top+'');

        return false;
    });

    $('.share-copy').click(function(event) {
        var url = $(this).data('link');
        var $alert = $('<span class="copy-alert">Link copied to your clipboard!</span>');

        var copyTextarea = document.createElement("textarea");
        copyTextarea.style.position = "fixed";
        copyTextarea.style.opacity = "0";
        copyTextarea.textContent = url;

        document.body.appendChild(copyTextarea);
        copyTextarea.select();
        document.execCommand("copy");
        document.body.removeChild(copyTextarea);

        $alert.appendTo($(this).parent()).fadeIn(300);

        setTimeout(function() {
            $('.copy-alert').fadeOut(200).delay(1000).remove;
        }, 5000);
    });

    $('.filter-initiatives').click(function(event) {
        var self = $(this)
        var filter = self.data("id");
        $('.filter-initiatives').removeClass("active");
        self.addClass("active");

        $('.initiatives-item').removeClass("hide");
        if(filter){
            $( '.initiatives-item' ).each( function() {
                if($(this).data('initiativetype')!=filter){
                    $(this).addClass("hide")
                }
            });
        }
    });

    $('#newsletter-form').submit(function() {
        var submitMessage = $(this).parent().find('.submit-message');
        $('#newsletter-form').addClass('loading');
        // $('#form-loading').removeClass('hide');

        $(this).ajaxSubmit({
            success: function(){
                // $('#form-loading').addClass('hide');
                $('#newsletter-form_Email').val('');
                $('#newsletter-form').addClass('hide');
                submitMessage.removeClass('hide');
            }
        });

        return false;
    });

    $('#contact-form').submit(function() {
        var submitMessage = $(this).parent().find('.submit-message');
        $('#contact-form').addClass('loading');

        $(this).ajaxSubmit({
            success: function(){
                // $('#newsletter-form_Email').val('');
                $('#contact-form').addClass('hide');
                submitMessage.removeClass('hide');
            }
        });

        return false;
    });

    $('#request-form').submit(function() {
        var submitMessage = $('#submit-message');
        $('#request-form').addClass('loading');

        $(this).ajaxSubmit({
            success: function(){
                $('#request-form').addClass('hide');
                submitMessage.removeClass('hide');
            }
        });

        return false;
    });

    $('#join-us-form').submit(function() {
        var submitMessage = $(this).parent().find('.submit-message');
        $('#join-us-form').addClass('loading');

        $(this).ajaxSubmit({
            success: function(){
                // $('#newsletter-form_Email').val('');
                $('#join-us-form').addClass('hide');
                submitMessage.removeClass('hide');
            }
        });

        return false;
    });

    $(document).on('click', '.involved-type', function() {
        let typeID = $(this).data('id');
        $('#join-us-form').show();
        $('#form-wrapper').hide();
        if (typeID == 'FundingRecipient') {
            $('#join-us-form').hide();
            $('#form-wrapper').html('<iframe style="width:100%;min-height:100vh;border:none;" src="https://app.harknwa.com/handlers/forms/standalone/302c06523bade2591f4e44960a2e39ab"></iframe>').show();
        } else {
            $("#join-us-form_Type").val(typeID);
        }
        $("#formModal").foundation('open');
    });

    $('#contact-form_Type').on('change', function(){
        if ($(this).val() == 'FundingRecipient') {
            $('#join-us-form').hide();
            $('#form-wrapper').html('<iframe style="width:100%;min-height:100vh;border:none;" src="https://app.harknwa.com/handlers/forms/standalone/302c06523bade2591f4e44960a2e39ab"></iframe>').show();
            $("#formModal").foundation('open');
        }
    });

    $('#join-us-form_Type').on('change', function(){
        if ($(this).val() == 'FundingRecipient') {
            $('#join-us-form').hide();
            $('#form-wrapper').html('<iframe style="width:100%;min-height:100vh;border:none;" src="https://app.harknwa.com/handlers/forms/standalone/302c06523bade2591f4e44960a2e39ab"></iframe>').show();
            $("#formModal").foundation('open');
        }
    });

    $(document).ready(function(){
        if ($('.formatted-slider').length > 0) {
            formattedSliderResize();
        }
    });

});
